import { render } from "./LongSleeve_8_front.vue?vue&type=template&id=65a37b35"
import script from "./LongSleeve_8_front.vue?vue&type=script&lang=js"
export * from "./LongSleeve_8_front.vue?vue&type=script&lang=js"

import exportComponent from "/srv/users/dyo-frontend/apps/dyo-frontend/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__